import { render, staticRenderFns } from "./datapsb.vue?vue&type=template&id=d63fe82e&"
import script from "./datapsb.vue?vue&type=script&lang=js&"
export * from "./datapsb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports